import { styled } from '@mui/material';

const ProfileLayout = styled('div')({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr 1fr 1fr',
  padding: 10,
  gap: 10,
});

export default ProfileLayout;